<div>
    <his-search-result #SearchResultComponent [showTitle]="true" [showNewSearchButton]="true"
        defaultActionRoute="/jobadvertisement/view/:id" idColumn="JobAdvertisement.id"
        defaultColumn="JobAdvertisement.shortDescription" [resultRowsPerPage]="100000"
        [resultListTemplate]="resultListTemplate" [showTableFilter]="false" [showSearchInfo]="false"
        [showTableConfig]="false">

        <ng-template #resultListTemplate let-data>
            <erp-jobadvertisement-search-result-list [data]="data" (page)="page($event)">
            </erp-jobadvertisement-search-result-list>
        </ng-template>
    </his-search-result>
</div>
